var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconImgUpload = function SvgIconImgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.25,
    fill: "#fff",
    stroke: "#DDDEE1",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m9.81 18.86-.007 2.288 2.287.008 5.925-5.886-2.31-2.267L9.81 18.86Zm10.585-5.956-1.316 1.308-2.31-2.266 1.346-1.337a.375.375 0 0 1 .53.002l1.752 1.763a.375.375 0 0 1-.002.53Zm-7.947 9.753a.625.625 0 0 0 .443-.182l8.562-8.507c.734-.73.738-1.917.008-2.651l-1.752-1.764a1.875 1.875 0 0 0-2.651-.008l-8.562 8.507a.625.625 0 0 0-.185.441L8.3 22.02a.625.625 0 0 0 .623.627l3.525.01Zm4.205-1.478a.75.75 0 0 0 0 1.5H23.3a.75.75 0 0 0 0-1.5h-6.647Z",
    fill: "#A4A7AD"
  })));
};
export default SvgIconImgUpload;